import { httpGet, httpPost, httpDownload } from '../../../utils/api.utils';
import { REQUEST_SUB_LINKS as RequestTable, REPORT_COLUMN_MODULE, DEFAULT_TABLE_RESULT_MODEL, REQUEST_TAB_NAME as RequestTabName } from '../../../constants/external-constants';
import Moment from 'moment';
import {
    setOrderApprovalData
    , setOrderCoverageData
    , setOrderAllRequestData
    , setOrderRequestData
    , setOrderQuotationData
    , setActiveRequestTable
    , setRequestSearch
    , setAllRequestSearch
    , setApprovalSearch
    , setQuotationSearch
    , setOrderSearchValue
    , setRequestTypes
    , setOrderFilterData
    , setPageIndex
    , setSortedColumnName
    , setDisplaySearch
    , setRequestLoading
    , setMyRequestPageSize
    , setAllRequestPageSize
    , setApprovalRequestPageSize
    , setQuotationRequestPageSize
    , setOrderRequestFilter
    , applyOrderRequestFilter
    , resetRequestLogData
} from '../../../constants/model-reducers/external/request/request-log.settings';
import { convertToFormatLocalDate, convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';


const initialState = {
    displaySearch: false
    , searchValue: null
    , filterBy: null
    , isFilter: false
    , activeRequestTable: 0
    , requestTypes: {}
    , isRequestTypesLoaded: false
    //Order All Request
    , orderAllRequestLoaded: false
    , orderAllRequestFetchError: false
    , pageIndex: 0
    , sortedColumnName: null
    , isSortAscending: false
    //Order Request
    , orderRequestData: DEFAULT_TABLE_RESULT_MODEL
    , orderRequestLoaded: false
    , orderRequestFetchError: false
    , pageIndex: 0
    , sortedColumnName: null
    , isSortAscending: false
    //Order Approval
    , orderApprovalLoaded: false
    , orderApprovalFetchError: false
    //Order Coverage
    , orderCoverageData: DEFAULT_TABLE_RESULT_MODEL
    , orderCoverageLoaded: false
    , orderCoverageFetchError: false
    //Order Quotation
    , orderQuotationData: DEFAULT_TABLE_RESULT_MODEL
    , orderQuotationLoaded: false
    , orderQuotationFetchError: false
    //Order Filters
    , orderFilterData: []
    , orderFilterLoaded: false
    , orderRequestTableFilterList: []
    , orderRequestTableFilterApply: false,

};

const latestRequestLogCalls = {};

function beginRequestLogCall(requestTableId) {
    latestRequestLogCalls[requestTableId] = (latestRequestLogCalls[requestTableId] || 0) + 1;
    return latestRequestLogCalls[requestTableId];
}

function isStaleRequestLogCall(state, requestTableId, callId) {
    return state().requestLog.activeRequestTable !== requestTableId
        || latestRequestLogCalls[requestTableId] !== callId;
}

export const requestLogActions = {
    fetchCreateRequestItems: (isTakeAction) => async dispatch => {
        isTakeAction = isTakeAction == undefined ? false : isTakeAction;

        dispatch({ type: setRequestTypes, requestTypes: {}, isLoaded: false });

        var requestTypes = await httpGet('external/requestLog/getRequestItems?isTakeAction=' + isTakeAction);

        dispatch({ type: setRequestTypes, requestTypes: requestTypes, isLoaded: true });
        return Promise.resolve(true);
    }
    , fetchRequestLogItems: (pageIndex, requestTableId, pageUnmount = false ) => async (dispatch, state) => {

        requestTableId = requestTableId !== undefined ? requestTableId : state().requestLog.activeRequestTable;
        const varPageIndex = pageIndex !== undefined ? pageIndex : state().requestLog.pageIndex;
        if (requestTableId == 0 || requestTableId == null || requestTableId == undefined) return;

        var data = getTableRequestPostData(requestTableId, state, pageUnmount);

        data.PageFilter = {
            "PageIndex": varPageIndex,
            "PageSize": data?.Pagination?.PerPage,
            "PageSizes": [10, 20, 30]
        }

        dispatch({
            type: setRequestLoading
            , isLoaded: data?.Pagination?.PerPage !== 10 ? true : state().requestLog.displaySearch
        });
        const callId = beginRequestLogCall(requestTableId);
        var requestLogItems = await httpPost(getTableRequestPostUrl(requestTableId), data);

        if (isStaleRequestLogCall(state, requestTableId, callId)) return;

        let dispatchActionType = getRequestTableType(requestTableId);

        if (requestLogItems.ok === false) {
            dispatch({
                type: dispatchActionType
                , data: DEFAULT_TABLE_RESULT_MODEL
                , isError: true
                , isLoaded: false
            });
        } else {
            dispatch({
                type: dispatchActionType
                , data: Object.keys(requestLogItems).length > 0 ? requestLogItems : DEFAULT_TABLE_RESULT_MODEL
                , isLoaded: true
                , isError: false
            });
        }
    }
    , fetchSortedRequestData: (columnClicked, isSortedAsc) => async (dispatch, state) => {

        let requestTableId = state().requestLog.activeRequestTable;

        if (requestTableId == 0 || requestTableId == null || requestTableId == undefined) return;

        var data = getTableRequestPostData(requestTableId, state);

        data.PageFilter = {
            "PageIndex": state().requestLog.pageIndex,
            "PageSize": data.Pagination.PerPage,
            "PageSizes": [10, 20, 30]
        }

        data.SortedColumnName = columnClicked;
        data.IsSortAscending = isSortedAsc;

        dispatch({
            type: setSortedColumnName,
            sortedColumnName: columnClicked,
            isSortAscending: isSortedAsc
        });


        return await postRequestData(dispatch, state, requestTableId, data);
    }
    , fetchFilterData: (filter) => async (dispatch, state) => {

        dispatch({
            type: setOrderFilterData,
            data: {},
            loaded: false
        });

        let tableId = state().requestLog.activeRequestTable;

        var data = getFilterDataParams(tableId, filter, state);

        var res = await httpPost(getFilterUrl(tableId), data);

        dispatch({
            type: setOrderFilterData,
            data: res,
            loaded: true
        });
    }
    , setActiveRequestTable: (requestTableId) => (dispatch) => {

        dispatch({
            type: setPageIndex,
            pageIndex: initialState.pageIndex
        });

        dispatch({
            type: setSortedColumnName,
            sortedColumnName: initialState.columnClicked,
            isSortAscending: initialState.isSortAscending
        });

        dispatch({
            type: setActiveRequestTable,
            id: requestTableId
        });
    },
    saveOrderRequestCustomCols: (selectedCols) => async (dispatch, state) => {
        try {
            var userId = sessionStorage.getItem('UserID');
            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.OrderRequestManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/inventory/saveCustomizeColumns', customizeFormData);

            dispatch({
                type: setRequestLoading,
                orderRequestFetchError: false,
                orderRequestLoaded: false
            });

            const requestTableId = state().requestLog.activeRequestTable;
            const varPageIndex = state().requestLog.pageIndex;
            if (requestTableId == 0 || requestTableId == null || requestTableId == undefined) return;

            var data = getTableRequestPostData(requestTableId, state);

            data.PageFilter = {
                "PageIndex": varPageIndex,
                "PageSize": data.Pagination.PerPage,
                "PageSizes": [10, 20, 30]
            }

            dispatch({
                type: setRequestLoading
                , isLoaded: data.Pagination.PerPage !== 10 ? true : state().requestLog.displaySearch
            });
            const callId = beginRequestLogCall(requestTableId);
            var requestLogItems = await httpPost(getTableRequestPostUrl(requestTableId), data);

            if (isStaleRequestLogCall(state, requestTableId, callId)) return;

            let dispatchActionType = getRequestTableType(requestTableId);

            if (requestLogItems.ok === false) {
                dispatch({
                    type: dispatchActionType
                    , data: DEFAULT_TABLE_RESULT_MODEL
                    , isError: true
                    , isLoaded: false
                });
            } else {
                dispatch({
                    type: dispatchActionType
                    , data: Object.keys(requestLogItems).length > 0 ? requestLogItems : DEFAULT_TABLE_RESULT_MODEL
                    , isLoaded: true
                    , isError: false
                });
            }
        }
        catch (e) {
            dispatch({
                type: setRequestLoading,
                orderRequestFetchError: true,
                orderRequestLoaded: false
            });
        }
    }
    ,setResetSearch: (key) => async (dispatch, state) =>{
        let requestTableId = state().requestLog.activeRequestTable;
        const { orderRequestData, orderQuotationData } = state().requestLog;

        switch (requestTableId) {
            case RequestTable.approvalRequest.id:
                let tableHeaderApproval = {
                    ...orderRequestData,
                    "Headers": {}
                }
                dispatch({
                    type: setApprovalSearch,
                    tableHeaderApproval: tableHeaderApproval,
                    orderApprovalLoaded: false
                });
                break;
            case RequestTable.allRequest.id:
                let tableHeaderAllRequest = {
                    ...orderRequestData,
                    "Headers": {}
                }
                dispatch({
                    type: setAllRequestSearch,
                    tableHeaderAllRequest: tableHeaderAllRequest,
                    orderAllRequestLoaded: false,
                });
                break;
            case RequestTable.orderRequest.id:
                let tableHeaderRequest = {
                    ...orderRequestData,
                    "Headers": {}
                }
                dispatch({
                    type: setRequestSearch,
                    tableHeaderRequest: tableHeaderRequest,
                    orderRequestLoaded: false
                });
                break;
            case RequestTable.quotationRequest.id:
                let tableHeaderQuotationRequest = {
                    ...orderQuotationData,
                    "Headers": {}
                }
                dispatch({
                    type: setQuotationSearch,
                    tableHeaderQuotationRequest: tableHeaderQuotationRequest,
                    orderQuotationLoaded: false
                });
                break;
            default:
        }
        
    }
    , resetRequestLogData: () => async (dispatch) => {
        dispatch({ type: resetRequestLogData, data: DEFAULT_TABLE_RESULT_MODEL });
    }

    , setRequestSearchValue: (event, key) => async (dispatch, state) => {
        let requestTableId = state().requestLog.activeRequestTable;

        var val = event.target.value;
        const { orderRequestData, orderQuotationData } = state().requestLog;
        switch (requestTableId) {
            case RequestTable.approvalRequest.id:
                let tableHeaderApproval = {
                    ...orderRequestData,
                    "Headers": {
                        ...orderRequestData.Headers,
                        [key]: {

                            ...orderRequestData.Headers[key],
                            searchString: val
                        }
                    }
                }
                dispatch({
                    type: setApprovalSearch,
                    tableHeaderApproval: tableHeaderApproval,
                    orderApprovalLoaded: true
                });
                break;
            case RequestTable.allRequest.id:
                let tableHeaderAllRequest = {
                    ...orderRequestData,
                    "Headers": {
                        ...orderRequestData.Headers,
                        [key]: {

                            ...orderRequestData.Headers[key],
                            searchString: val
                        }
                    }
                }
                dispatch({
                    type: setAllRequestSearch,
                    tableHeaderAllRequest: tableHeaderAllRequest,
                    orderAllRequestLoaded: true,
                });
                break;
            case RequestTable.orderRequest.id:
                let tableHeaderRequest = {
                    ...orderRequestData,
                    "Headers": {
                        ...orderRequestData.Headers,
                        [key]: {

                            ...orderRequestData.Headers[key],
                            searchString: val
                        }
                    }
                }
                dispatch({
                    type: setRequestSearch,
                    tableHeaderRequest: tableHeaderRequest,
                    orderRequestLoaded: true
                });
                break;
            case RequestTable.quotationRequest.id:
                let tableHeaderQuotationRequest = {
                    ...orderQuotationData,
                    "Headers": {
                        ...orderQuotationData.Headers,
                        [key]: {

                            ...orderQuotationData.Headers[key],
                            searchString: val
                        }
                    }
                }
                dispatch({
                    type: setQuotationSearch,
                    tableHeaderQuotationRequest: tableHeaderQuotationRequest,
                    orderQuotationLoaded: true
                });
                break;
            default:
        }


    },
    isDisplaySearch: (val) => (dispatch) => {
        dispatch({
            type: setDisplaySearch
            , value: val
        });
    },

    addOrderRequestFilter: (tableFilter) => (dispatch, state) => {
        const { orderRequestTableFilterList } = state().requestLog;
        var filterList = [...orderRequestTableFilterList, tableFilter];

        dispatch({
            type: setOrderRequestFilter,
            filterList: filterList
        })
    },

    removeOrderRequestFilter: (removeIndex) => (dispatch, state) => {
        const { orderRequestTableFilterList } = state().requestLog;

        var filterList = orderRequestTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setOrderRequestFilter,
            filterList: filterList
        })
    },

    extractRequsetLogs: () => async (dispatch, state) => {
        let requestTableId = state().requestLog.activeRequestTable;
        var data = getTableRequestPostData(requestTableId, state)
        httpDownload('external/requestLog/getExtractRequestLog', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, data.FileName);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = data.FileName + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    applyOrderRequestFilter: (isApply) => (dispatch, state) => {
        const { orderRequestTableFilterList } = state().requestLog;

        dispatch({
            type: applyOrderRequestFilter,
            applyFilter: isApply,
            filterList: isApply ? orderRequestTableFilterList : []
        });
    },
    
    resizeRequestLogs: (pageSize) => async (dispatch, state) => {
        let requestTableId = state().requestLog.activeRequestTable;

        switch (requestTableId) {
            case RequestTable.allRequest.id:
                dispatch({
                    type: setAllRequestPageSize,
                    pageSize: parseInt(pageSize),
                });
                break;
            case RequestTable.orderRequest.id:
                dispatch({
                    type: setMyRequestPageSize,
                    pageSize: parseInt(pageSize),
                });
                break;
            case RequestTable.approvalRequest.id:
                dispatch({
                    type: setApprovalRequestPageSize,
                    pageSize: parseInt(pageSize),
                });
                break;
            case RequestTable.quotationRequest.id:
                dispatch({
                    type: setQuotationRequestPageSize,
                    pageSize: parseInt(pageSize)
                })
            default:
        }
    }
}
function getFilterUrl(tableId) {
    switch (tableId) {
        case RequestTable.approvalRequest.id:
        case RequestTable.allRequest.id:
        case RequestTable.orderRequest.id:
            return 'external/requestLog/GetFilters';
            break;
        case RequestTable.quotationRequest.id:
            return 'external/requestLog/getQuotationReqFilters';
            break;
        default:
    }
}

function getFilterDataParams(tableId, filter, state) {
    switch (tableId) {
        case RequestTable.approvalRequest.id:
        case RequestTable.allRequest.id:
        case RequestTable.orderRequest.id:
            return {
                "CreatedByFullName": sessionStorage.FirstName + " " + sessionStorage.MiddleInitial + " " + sessionStorage.LastName,
                "PageFilter": {
                    PageIndex: 0, PageSizes: [
                        10,
                        20,
                        30
                    ]
                },
                "searchValue": filter,
                "isForApproval": tableId == RequestTable.approvalRequest.id,
                "IsGetAll": true,
                "UserRoleId": sessionStorage.UserRoleID,
                "Eid": JSON.parse(sessionStorage.User).Employee.EnterpriseId,
                "UserId": sessionStorage.UserID,
                "EmployeeId": sessionStorage.EmployeeID,
                "OtherSubscribersList": state().navMenu.subsUnderLineManager
            }
            break;
        case RequestTable.quotationRequest.id:
            return {
                'IsGetAll':true
                ,'PageFilter': { PageIndex: 0 }
                ,'searchValue': filter
            };
            break;
        default:
    }
}

async function postRequestData(dispatch, state, requestTableId, data) {

    const callId = beginRequestLogCall(requestTableId);
    var requestLogItems = await httpPost(getTableRequestPostUrl(requestTableId), data);

    if (isStaleRequestLogCall(state, requestTableId, callId)) return Promise.resolve(false);

    let dispatchActionType = getRequestTableType(requestTableId);

    if (requestLogItems.ok === false) {
        dispatch({
            type: dispatchActionType
            , data: DEFAULT_TABLE_RESULT_MODEL
            , isError: true
            , isLoaded: false
        });
    } else {
        dispatch({
            type: dispatchActionType
            , data: Object.keys(requestLogItems).length > 0 ? requestLogItems : DEFAULT_TABLE_RESULT_MODEL
            , isLoaded: true
            , isError: false
        });
    }

    return Promise.resolve(true);
}

function getRequestTableType(id) {
    let type;

    switch (id) {
        case RequestTable.approvalRequest.id:
            type = setOrderApprovalData;
            break;
        case RequestTable.coverageRequest.id:
            type = setOrderCoverageData;
            break;
        case RequestTable.orderRequest.id:
            type = setOrderRequestData;
            break;
        case RequestTable.quotationRequest.id:
            type = setOrderQuotationData;
            break;
        case RequestTable.allRequest.id:
            type = setOrderAllRequestData;
            break;
        default:
    }

    return type;
}
function getTableRequestPostData(id, state, pageUnmount = false) {
    const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
    const { searchValue, filterBy, isFilter, orderRequestData,orderQuotationData, orderRequestTableFilterList, orderRequestTableFilterApply, pagIndex } = state().requestLog;
    const dealName = sessionStorage.getItem('DealName');
    const formattedTimeZoneDate = convertToFormatTimeZoneDate(
        new Date(), 
        activeDateFormat?.Name || "YYYY-MM-DD", 
        activeTimeZoneOffset?.UtcOffset || 0)
        .replace(/[<>:"/\|?*]/g, '-');  
    var filename = `ATEM ${dealName} Order Extract – ${formattedTimeZoneDate}`;

    let data = {
        "Eid": JSON.parse(sessionStorage.User).Employee.EnterpriseId
        , "UserId": sessionStorage.UserID
        , "UserRoleId": sessionStorage.UserRoleID
        , "EmployeeId": sessionStorage.EmployeeID
        , "isForApproval": false
        , "IsGetAll": searchValue != null && searchValue != "" ? false : true
        , "OtherSubscribersList": state().navMenu.subsUnderLineManager
        , "FilterBy": filterBy
        , "FileName": filename
        , "SortedColumnName": state().requestLog.sortedColumnName
        , "IsSortAscending": state().requestLog.isSortAscending
        , "IsFilter": isFilter
        , "searchValue": searchValue
    };
    switch (id) {
        case RequestTable.approvalRequest.id:
            data.Headers = pageUnmount? {} : orderRequestData.Headers
               data.Pagination = {
                "PerPage": orderRequestData.Pagination.PerPage
            }
            data.isForApproval = true;
            data.ApplyFilter = orderRequestTableFilterApply
            data.TableFilterList = orderRequestTableFilterList
            data.TabName = RequestTabName.approvalRequest
            break;
        case RequestTable.coverageRequest.id:
            data.PermissionCoverages = [];
            data.ApplyFilter = false;
            data.FilterModel = { "Region": [], "Country": [], "Vendor": [], "Account": [], "Status": [], "FilterTitle": "" };
            data.UserRolePermissionId = 3;
            break;
        case RequestTable.allRequest.id:
            data.Headers = pageUnmount? {} : orderRequestData.Headers
            data.Pagination = {
                "PerPage": orderRequestData.Pagination.PerPage
            }
            data.isAllRequest = true;
            data.ApplyFilter = orderRequestTableFilterApply
            data.TableFilterList = orderRequestTableFilterList
            data.TabName = RequestTabName.allOrderRequest
            break;
        case RequestTable.orderRequest.id:
            data.Headers = pageUnmount? {} : orderRequestData.Headers
            data.Pagination = {
                "PerPage" : orderRequestData.Pagination.PerPage
            }
            data.isAllRequest = false;
            data.ApplyFilter = orderRequestTableFilterApply
            data.TableFilterList = orderRequestTableFilterList
            data.TabName = RequestTabName.myRequest
            break;
        case RequestTable.quotationRequest.id:
            data.Headers = pageUnmount? {} : orderQuotationData.Headers
            data.Pagination = {
                "PerPage" : orderQuotationData.Pagination.PerPage
            }
            data.isAllRequest = false;
            data.ApplyFilter = orderRequestTableFilterApply
            data.TableFilterList = orderRequestTableFilterList
            data.TabName = RequestTabName.quotationRequest
            break;
        default:
    }

    return data;
}
function getTableRequestPostUrl(id) {
    let url;

    switch (id) {
        case RequestTable.approvalRequest.id:
        case RequestTable.allRequest.id:
        case RequestTable.orderRequest.id:
            url = 'external/requestLog/getRequestLog';
            break;
        case RequestTable.coverageRequest.id:
            url = 'external/requestLog/getRequestLogCoverageInitialLoad';
            break;
        case RequestTable.quotationRequest.id:
            url = 'external/requestLog/getQuotationLog';
        default:
    }

    return url
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setRequestLoading:
            return {
                ...state
                , orderRequestLoaded: action.isLoaded
                , orderAllRequestLoaded: action.isLoaded
                , orderApprovalLoaded: action.isLoaded
            };
        case setRequestTypes:
            return {
                ...state,
                orderRequestLoaded: action.isLoaded
            };
        //Order Request Table Update
        case setOrderApprovalData:
            return {
                ...state,
                orderRequestData: action.data
                , orderApprovalLoaded: action.isLoaded
                , orderApprovalFetchError: action.isError
            };
        case setOrderCoverageData:
            return {
                ...state,
                orderCoverageData: action.data
                , orderCoverageLoaded: action.isLoaded
                , orderCoverageFetchError: action.isError
            };
        case setOrderAllRequestData:
            return {
                ...state,
                orderRequestData: action.data
                , orderAllRequestLoaded: action.isLoaded
                , orderAllRequestFetchError: action.isError
            };
        case setOrderRequestData:
            return {
                ...state,
                orderRequestData: action.data
                , orderRequestLoaded: action.isLoaded
                , orderRequestFetchError: action.isError
            };
        case setOrderQuotationData:
            return {
                ...state,
                orderQuotationData: action.data
                , orderQuotationLoaded: action.isLoaded
                , orderQuotationFetchError: action.isError
            };
        // ---- end -----

        case setActiveRequestTable:
            return {
                ...state,
                activeRequestTable: action.id
            };
        case setAllRequestSearch:
            return {
                ...state,
                orderRequestData: action.tableHeaderAllRequest,
                orderAllRequestLoaded: action.orderAllRequestLoaded
            }
        case setPageIndex:
            return {
                ...state
                , pageIndex: action.pageIndex
            };
        case setSortedColumnName:
            return {
                ...state
                , sortedColumnName: action.sortedColumnName
                , isSortAscending: action.isSortAscending
            };
        case setDisplaySearch:
            return {
                ...state
                , displaySearch: action.value
            };
        // --- Column Search
        case setRequestSearch:
            return {
                ...state,
                orderRequestData: action.tableHeaderRequest,
                orderRequestLoaded: action.orderRequestLoaded
            }
        case setApprovalSearch:
            return {
                ...state,
                orderRequestData: action.tableHeaderApproval,
                orderApprovalLoaded: action.orderApprovalLoaded
            }
        case setOrderFilterData:
            return {
                ...state,
                orderFilterData: action.data
                , orderFilterLoaded: action.loaded
            };
        case setQuotationSearch:
            return {
                ...state,
                orderQuotationData: action.tableHeaderQuotationRequest,
                orderQuotationLoaded: action.orderQuotationLoaded
            }

        // --- Page Resize
        case setAllRequestPageSize:
            return {
                ...state,
                orderRequestData: {
                    ...state.orderRequestData,
                    Pagination: {
                        ...state.orderRequestData.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case setMyRequestPageSize:
            return {
                ...state,
                orderRequestData: {
                    ...state.orderRequestData,
                    Pagination: {
                        ...state.orderRequestData.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case setApprovalRequestPageSize:
            return {
                ...state,
                orderRequestData: {
                    ...state.orderRequestData,
                    Pagination: {
                        ...state.orderRequestData.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case setQuotationRequestPageSize:
            return {
                ...state,
                orderQuotationData: {
                    ...state.orderQuotationData,
                    Pagination: {
                        ...state.orderQuotationData.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setOrderRequestFilter:
            return {
                ...state,
                orderRequestTableFilterList: action.filterList
            }
        case applyOrderRequestFilter:
            return {
                ...state,
                orderRequestTableFilterApply: action.applyFilter,
                orderRequestTableFilterList: action.filterList
            }
        case resetRequestLogData:
            return {
                ...state,
                orderRequestData: action.data,
                orderQuotationData: action.data,
            };
        default: return state;
    }
}